import request from '@/plugins/requestU'
import Config from '@/config'

// 获取路由
export const getMenuTreeByPid = query => {
  return request.service({
    url: '/rbac/v0.1/menu/getMenuTreeByPid',
    method: 'post',
    params: query
  })
}

